import React from "react";
import BlogItem from "../../components/common/BlogItem";
import LoadMore from "../../components/common/LoadMore";
import { blog } from "../../data/Data";

const OurBlogs = () => {
  return (
    <>
      <section className="our-blog">
        <div className="container">
          <h2 className="pageTitle">
            Our Bl<span>og</span>
          </h2>
          <div className="our-blog-items">
            {blog.slice(0, 8).map((blogItem) => {
              return <BlogItem blogItem={blogItem} key={blogItem.id} />;
            })}
          </div>
          <LoadMore btnTitle="Load more Collections" />
        </div>
      </section>
    </>
  );
};

export default OurBlogs;
